import script from "./HeaderUserDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderUserDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderUserDropdown.vue?vue&type=style&index=0&id=a68d7684&scoped=true&lang=css"
import "./HeaderUserDropdown.vue?vue&type=style&index=1&id=a68d7684&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a68d7684"]])

export default __exports__